export default "__VITE_ASSET__BHdYDFtR__"